import { Link } from "react-router-dom";
import { Button, Card } from "../components/ui";

export function NotFoundPage() {
  return (
    <div className="public-page">
      <Card className="success-card">
        <h1>Página não encontrada</h1>
        <p>O endereço informado não existe neste ambiente.</p>
        <Link to="/">
          <Button>Voltar ao painel</Button>
        </Link>
      </Card>
    </div>
  );
}
